import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLgtmComponent } from './simple-icons-lgtm.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLgtmComponent ],
    exports:      [ SimpleIconsLgtmComponent ],
    bootstrap:    []
})
export class SimpleIconsLgtmModule {}
